export const numberMask = (value: string) => {
  return value.replace(/\D/g, '');
};
